import { BackgroundColor as HygraphBackgroundColor } from '@/lib/types';

export enum BackgroundColor {
  WHITE = 'WHITE',
  PRIMARY_LIGHT = 'PRIMARY_LIGHT',
  LIGHT_BLUE = 'LIGHT_BLUE',
  LIGHT_PURPLE = 'LIGHT_PURPLE',
}

export const backgroundColorToEnumMap: Record<
  HygraphBackgroundColor,
  BackgroundColor
> = {
  [HygraphBackgroundColor.White]: BackgroundColor.WHITE,
  [HygraphBackgroundColor.LightPink]: BackgroundColor.PRIMARY_LIGHT,
  [HygraphBackgroundColor.LightBlue]: BackgroundColor.LIGHT_BLUE,
  [HygraphBackgroundColor.LightPurple]: BackgroundColor.LIGHT_PURPLE,
};

export const backgroundColorToColorNameMap = {
  [BackgroundColor.WHITE]: 'bg-white',
  [BackgroundColor.PRIMARY_LIGHT]: 'bg-primary-light',
  [BackgroundColor.LIGHT_BLUE]: 'bg-light-blue',
  [BackgroundColor.LIGHT_PURPLE]: 'bg-light-purple',
};
